import React from "react";
import "./css/PhysioTracker.css";
import { Link } from "react-router-dom";

function PhysioTracker(props) {
  return (
    <Link
      to="/welcome"
      className={`physio-tracker logo ${props.className}`}
      style={{ ...props.style }}
    >
      <span style={{ fontSize: `${props.size}rem` }}>Physio</span>
      <span style={{ fontSize: `${props.size}rem` }}>Track</span>
    </Link>
  );
}

export default PhysioTracker;
